var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M38.1,9.9H7c-0.3,0-0.5,0.2-0.5,0.5v23.1C6.5,33.8,6.7,34,7,34h4.4v0.8c0,0.2,0.1,0.3,0.3,0.3h2.4 c0.2,0,0.3-0.1,0.3-0.3V34h16.3v0.8c0.1,0.1,0.2,0.2,0.3,0.3h2.5c0.1,0,0.2-0.2,0.2-0.3V34h4.4c0.3,0,0.5-0.2,0.5-0.5V10.4 C38.5,10.1,38.3,9.9,38.1,9.9z M37.6,10.9v3.5H7.5v-3.5H37.6z M7.5,33V15.4h10.2v0.3c0,0.1,0.1,0.2,0.2,0.2h9.3 c0.2,0,0.3-0.1,0.3-0.2v-0.3h10.1V33H7.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M27.5,15.4v0.3c0,0.1-0.1,0.2-0.3,0.2h-9.3c-0.1,0-0.2-0.1-0.2-0.2v-0.3H7.5V33h30.1V15.4H27.5z M26.2,23 L26,23.5l-1-0.6l-1.8,1L25,25l1-0.6l0.3,0.5l-0.7,0.4l1,0.6l-0.3,0.5l-1-0.6v0.8h-0.6v-1.1l-1.8-1v2l1,0.6l-0.3,0.5l-0.7-0.4v1.2 h-0.6v-1.2l-0.7,0.4l-0.3-0.5l1-0.6v-2l-1.8,1v1.1h-0.6v-0.8l-1.1,0.6l-0.3-0.5l1.1-0.6l-0.7-0.4l0.3-0.5l1,0.6l1.8-1.1l-1.8-1 l-1,0.6L18.9,23l0.7-0.4L18.5,22l0.3-0.6l1.1,0.6v-0.8h0.6v1.2l1.8,1v-2.1l-1-0.5l0.3-0.5l0.7,0.4v-1.3h0.6v1.3l0.7-0.4l0.3,0.5 l-1,0.5v2.1l1.8-1v-1.2h0.6V22l1-0.6l0.3,0.6l-1,0.6L26.2,23z M35.2,31h-2.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.3 c0.3,0,0.5,0.2,0.5,0.5S35.4,31,35.2,31z M35.2,29.1h-2.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.3c0.3,0,0.5,0.2,0.5,0.5 S35.4,29.1,35.2,29.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "17.9,14.4 27.2,14.4 37.6,14.4 37.6,10.9 7.5,10.9 7.5,14.4 "
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M35.2,28.1h-2.3c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h2.3c0.3,0,0.5-0.2,0.5-0.5S35.4,28.1,35.2,28.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M35.2,30h-2.3c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h2.3c0.3,0,0.5-0.2,0.5-0.5S35.4,30,35.2,30z"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#4AB8DC",
  points: "26.2,21.4 25.2,22 25.2,21.2 24.7,21.2 24.7,22.4 22.9,23.4 22.9,21.3 23.9,20.8 23.6,20.3  22.9,20.7 22.9,19.4 22.2,19.4 22.2,20.7 21.6,20.3 21.2,20.8 22.2,21.3 22.2,23.4 20.5,22.4 20.5,21.2 19.9,21.2 19.9,22  18.8,21.4 18.5,22 19.6,22.6 18.9,23 19.2,23.5 20.2,22.9 22,23.9 20.2,25 19.2,24.4 18.9,24.9 19.6,25.3 18.5,25.9 18.8,26.4  19.9,25.8 19.9,26.6 20.5,26.6 20.5,25.5 22.2,24.5 22.2,26.5 21.2,27.1 21.6,27.6 22.2,27.2 22.2,28.4 22.9,28.4 22.9,27.2  23.6,27.6 23.9,27.1 22.9,26.5 22.9,24.5 24.7,25.5 24.7,26.6 25.2,26.6 25.2,25.8 26.2,26.4 26.6,25.9 25.6,25.3 26.2,24.9  26,24.4 25,25 23.2,23.9 25,22.9 26,23.5 26.2,23 25.6,22.6 26.6,22 "
});

function SvgDryIce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryIce);
export default __webpack_public_path__ + "static/media/dry_ice.e12e32b0fb32ae89915d334176354be5.svg";
export { ForwardRef as ReactComponent };